// @ai-generated 2026-08-05T00:00:00+00:00 by malte.ulfers@tngtech.com using Claude Opus 4.7
// These types are hand-authored on purpose. Our TypeGen doesn't emit the two shapes we need
// for the ruleset AST:
//   - Discriminated unions with a `type` string literal (backend uses
//     [JsonPolymorphic(TypeDiscriminatorPropertyName = "type")] + [JsonDerivedType]).
//   - String enums (backend uses [JsonStringEnumConverter], wire format is "Eq" / "All" /
//     "Soft"). TypeGen emits numeric enums which would round-trip incorrectly.

// Enums are NUMERIC on the wire. The backend's ServiceDefaults registers a
// StrictEnumJsonConverterFactory in the MVC JsonSerializerOptions.Converters collection, and a
// converter registered there overrides a [JsonConverter(typeof(JsonStringEnumConverter))] attribute
// on the enum type. So even though the Api ruleset enums carry that attribute, they serialize as
// ordinals like every other enum in this repo — and the factory rejects strings on read by design.
// The ordinals below must stay in sync with the member order in
// Lib/Model/Synqo.Cloud.Model.Domain/Rulesets/SynqoRuleset.cs; RulesetWireFormatTest pins them.

export enum SynqoRuleSeverity {
    Soft = 0,
    Hard = 1,
}

export enum SynqoCompareOperator {
    Eq = 0,
    Neq = 1,
    Gt = 2,
    Gte = 3,
    Lt = 4,
    Lte = 5,
}

/**
 * Unary presence operators. These carry the engine's negation — there is deliberately no `not`
 * combinator, because a combinator cannot distinguish a genuine false from a null-induced failure.
 */
export enum SynqoUnaryOperator {
    IsNull = 0,
    IsNotNull = 1,
    IsEmpty = 2,
    IsNotEmpty = 3,
}

export enum SynqoAggregateFunction {
    Count = 0,
    Sum = 1,
    Min = 2,
    Max = 3,
    Avg = 4,
}

/** Dotted field path. Used where a path is structural (for_each collection, ruleset_ref target). */
export interface SynqoFieldReference {
    path: string;
}

export interface SynqoLiteralOperand {
    kind: 'literal';
    value: unknown;
}

export interface SynqoFieldOperand {
    kind: 'field';
    path: string;
}

export interface SynqoAggregateOperand {
    kind: 'aggregate';
    function: SynqoAggregateFunction;
    collection: string;
    /** Required for every function except `Count`. */
    field?: string;
    /**
     * Optional predicate narrowing the collection before the fold. Restricted to a simple predicate —
     * `compare`/`predicate`, optionally combined with `and`/`or`; the backend rejects anything else.
     */
    where?: SynqoCondition;
}

/** A path resolved against a named ambient shape rather than the entity under validation. */
export interface SynqoAmbientOperand {
    kind: 'ambient';
    shape: string;
    path: string;
}

/** A value position inside a condition — the `kind` discriminator mirrors the backend AST. */
export type SynqoOperand = SynqoLiteralOperand | SynqoFieldOperand | SynqoAggregateOperand | SynqoAmbientOperand;

/** How precisely a comparison is made. Only meaningful for temporal operands. */
export enum SynqoCompareGranularity {
    Exact = 0,
    Date = 1,
}

export interface SynqoCompareCondition {
    type: 'compare';
    operator: SynqoCompareOperator;
    left: SynqoOperand;
    right: SynqoOperand;
    message?: string;
    /** Absent on older ASTs and on every non-temporal compare; treat as `Exact`. */
    granularity?: SynqoCompareGranularity;
}

export interface SynqoPredicateCondition {
    type: 'predicate';
    operator: SynqoUnaryOperator;
    operand: SynqoOperand;
    message?: string;
}

export interface SynqoAndCondition {
    type: 'and';
    children: SynqoCondition[];
}

export interface SynqoOrCondition {
    type: 'or';
    children: SynqoCondition[];
}

export enum SynqoForEachMode {
    All = 0,
    Any = 1,
}

export interface SynqoForEachCondition {
    type: 'for_each';
    collection: SynqoFieldReference;
    mode: SynqoForEachMode;
    body: SynqoCondition;
}

/**
 * Narrows `collection` to the items satisfying `where`, then applies `body` to the survivors.
 * A filtered-out item contributes no failure messages — the filter selects, it does not assert.
 *
 * `where` is restricted to a simple predicate (`compare`/`predicate`, optionally combined with
 * `and`/`or`); `body` is unrestricted. Typed as the full union because the constraint is enforced
 * server-side, so a renderer must still handle whatever arrives.
 */
export interface SynqoFilteredCondition {
    type: 'filtered';
    collection: SynqoFieldReference;
    where: SynqoCondition;
    mode: SynqoForEachMode;
    body: SynqoCondition;
}

export interface SynqoRulesetReferenceCondition {
    type: 'ruleset_ref';
    target: SynqoFieldReference | null;
    root_entity_type: string;
    ruleset_key: string;
}

export interface SynqoIfThenElseCondition {
    type: 'if_then_else';
    if: SynqoCondition;
    then: SynqoCondition;
    else?: SynqoCondition;
}

export type SynqoCondition =
    | SynqoCompareCondition
    | SynqoPredicateCondition
    | SynqoAndCondition
    | SynqoOrCondition
    | SynqoForEachCondition
    | SynqoFilteredCondition
    | SynqoRulesetReferenceCondition
    | SynqoIfThenElseCondition;

export interface SynqoRuleset {
    id: string;
    title: string;
    entity_type: string;
    severity: SynqoRuleSeverity;
    message?: string;
    root: SynqoCondition;
}

export interface ApiRulesetDetail {
    id: string;
    key: string;
    title: string;
    entity_type: string;
    description: string;
    ast: SynqoRuleset;
    referenced_rulesets: Record<string, SynqoRuleset>;
}
